export const Admin = {
  Name: "Панель адміністратора",
  Emoji: "👷",
};
